import React, {useEffect, useState } from 'react';
import {MDBCol, MDBIcon, MDBRow} from "mdbreact";
import {Button, Container} from "@nextui-org/react";
import Headerbar from "../../navBars/Headerbar";
import Sidebar from "../../navBars/Sidebar";
import {Layout, Table} from "antd";
import { Input } from "@nextui-org/react";
import AddSeller from '../../Drawers/Seller/AddSeller';
import {useCollection} from "react-firebase-hooks/firestore";
import {collection, getFirestore} from "firebase/firestore";
import Firebase from "../../Firebase/Firebase";
import {ColumnsType} from "antd/lib/table";
import {generatePath, useNavigate} from "react-router-dom";
import {Tag} from "primereact/tag";


interface DataType {
    key: number;
    name: string;
    phone: string;
    location: string;
    trustTier: JSX.Element;
    createdAt: string;
    action: JSX.Element;
}
const { Content } = Layout;
const db = getFirestore(Firebase);
const Sellers = () => {

    const columns: ColumnsType<DataType> = [
        {
            title: '#',
            dataIndex: 'key',
            key: 'key',
            width: 50,
            render: text => <a>{text}</a>,
        },
        {
            title: 'Seller',
            dataIndex: 'name',
            key: 'name',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
        },
        {
            title: 'Trust Tier',
            dataIndex: 'trustTier',
            key: 'trustTier',
        },
        {
            title: 'Joined',
            dataIndex: 'createdAt',
            key: 'createdAt',
        },
        {
            title: 'Action',
            key: 'action',
            dataIndex: 'action'
        },
    ];

    const [collapsed, setCollapsed] = useState(false);
    const [addModal, setAddModal] = useState(false);
    // Fetch all users and filter client-side — covers all field-name/value variants
    // (Type:"Seller", type:"seller", type:"Seller") across old and new accounts.
    const [userSnapshot, loading] = useCollection(
        collection(db, 'users'),
        { snapshotListenOptions: { includeMetadataChanges: true } }
    );
    const navigate = useNavigate();
    const [sellerArray, setSellerArray] = useState<any[]>([]);
    const [dataArray, setDataArray] = useState<DataType[]>([]);

    function isSeller(d: any): boolean {
        const t = d.type ?? d.Type ?? '';
        return t.toLowerCase() === 'seller';
    }

    function getTrustTag(tier: string, kycExpiresAt: any): JSX.Element {
        const isExpired = kycExpiresAt
            ? (kycExpiresAt.toDate ? kycExpiresAt.toDate() : new Date(kycExpiresAt)) < new Date()
            : false;
        const effectiveTier = (tier === 'trusted' && isExpired) ? 'basic' : tier;
        const severity = effectiveTier === 'trusted' ? 'success'
            : effectiveTier === 'basic' ? 'info'
            : 'warning';
        const label = effectiveTier === 'trusted' ? 'Trusted'
            : effectiveTier === 'basic' ? 'Basic'
            : 'None';
        return <Tag severity={severity as any} value={label} />;
    }

    useEffect(() => {
        if (!userSnapshot) return;

        const emptyArray: DataType[] = [];
        userSnapshot.docs.forEach((docSnap: any, index: number) => {
            const item = docSnap.data();
            if (!isSeller(item)) return;
            emptyArray.push({
                key: emptyArray.length + 1,
                name: item.fullName ?? item.Fullname ?? '',
                phone: item.phoneNumberAuth ?? item.Phonenumber ?? '',
                location: item.location ?? item.Location ?? '',
                trustTier: getTrustTag(item.trustTier ?? 'none', item.kycExpiresAt),
                createdAt: item.dateJoined ?? item.DateJoined ?? '',
                action: <Button size="xs" onClick={() => {
                    navigate(generatePath('/shops/:id', {id: item.Uid ?? docSnap.id}));
                }} rounded color="primary" icon={<MDBIcon icon="eye"/>}/>
            });
        });

        setDataArray([...emptyArray]);
        setSellerArray([...emptyArray]);
    }, [userSnapshot]);

    const searchFilter = (searchText: string) => {
        const lower = searchText.toLowerCase();
        const filteredArray = sellerArray.filter(({name, location}) => {
            return (name?.toLowerCase() ?? '').includes(lower)
                || (location?.toLowerCase() ?? '').includes(lower);
        });
        setDataArray([...filteredArray]);
    }

    return (
        <>
            <Layout style={{ minHeight: '100vh' }}>

                <Headerbar collapsed={collapsed} setCollapsed={setCollapsed}/>
                <Layout className="site-layout">
                    <Sidebar collapsed={collapsed}/>
                    <Content>
                        <Container className="mt-2">
                            <AddSeller openDrawer={addModal} closeDrawer={setAddModal}/>
                            <MDBRow>
                                <MDBCol>
                                    <div className="page-header">
                                        <h4 className="page-title">
                                            Sellers
                                            <span className="page-title-count">({dataArray.length})</span>
                                        </h4>
                                        <div style={{display:'flex', gap:8, alignItems:'center'}}>
                                            <Input
                                                placeholder="search sellers"
                                                onChange={(e) => { searchFilter(String(e.target.value))}}
                                                contentRight={<MDBIcon icon="search"/>}
                                            />
                                            <Button color="primary" auto shadow onPress={() => setAddModal(true)}>
                                                Add
                                            </Button>
                                        </div>
                                    </div>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol>
                                    <div style={{background:'#fff', borderRadius:12, border:'1px solid #eee',
                                                 boxShadow:'0 1px 4px rgba(0,0,0,.06)', overflow:'hidden', marginTop:8}}>
                                        <Table columns={columns} dataSource={dataArray} loading={loading}
                                               size="middle"
                                               pagination={{ defaultPageSize: 25, showSizeChanger: true,
                                                             pageSizeOptions:['25','50'],
                                                             showTotal: (t: number, r: number[]) => `${r[0]}–${r[1]} of ${t}` }}/>
                                    </div>
                                </MDBCol>
                            </MDBRow>
                        </Container>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}

export default Sellers;
